<template>
  <v-app>
    <v-navigation-drawer
      class="nav-drawer"
      v-model="drawer"
      right
      absolute
      width="330"
      temporary
    >
      <div class="drawer-icon-cont">
        <v-app-bar-nav-icon
          class="drawer-close"
          @click.stop="drawer = !drawer"
        ></v-app-bar-nav-icon>
      </div>

      <v-list-item class="drawer-header">
        <v-list-item-avatar>
          <v-img src="./assets/images/mm-lights-sm.jpg"></v-img>
        </v-list-item-avatar>

        <v-list-item-content class="nav-title-cont">
          <v-list-item-title class="nav-title-head"
            ><span class="color-mcf-blue">Michael</span>-<span
              class="color-mcf-blue"
              >McFarland</span
            >.com</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense nav>
        <v-list-item
          v-for="item in items"
          :key="item.title"
          :href="item.anchor"
          @click.stop="drawer = !drawer"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      class="mcf-app-bar"
      absolute
      elevate-on-scroll
      height="50"
      scroll-target="#scrolling-target-1"
    >
      <div class="nav-mcf-flame-logo"></div>
      <v-toolbar-title class="mm-logo-header">McFarland Web</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
    </v-app-bar>

    <v-sheet id="scrolling-target-1" class="overflow-y-auto" max-height="100vh">
      <v-main>
        <div id="main-content" class="overflow-y-auto">
          <Loader />
          <McFarlandHero />
          <About />
          <Experience />
          <SkillsTech />
          <SoftwareDev />
          <FeaturedProjects />
          <RadioRecliner />
          <CtaQuote />
          <Contact />
          <Footer />
        </div>
      </v-main>
    </v-sheet>
  </v-app>
</template>

<script>
import Loader from "./components/Loader";
import HelloWorld from "./components/HelloWorld";
import McFarlandHero from "./components/McFarlandHero";
import About from "./components/About";
import Experience from "./components/Experience";
import CitySunParallax from "./components/CitySunParallax";
import SkillsTech from "./components/SkillsTech";
import FeaturedProjects from "./components/FeaturedProjects";
import RadioRecliner from "./components/RadioRecliner";
import SoftwareDev from "./components/SoftwareDev";
import CtaQuote from "./components/CtaQuote";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

export default {
  name: "App",

  components: {
    Loader,
    HelloWorld,
    McFarlandHero,
    About,
    CitySunParallax,
    Experience,
    SkillsTech,
    SoftwareDev,
    CtaQuote,
    FeaturedProjects,
    RadioRecliner,
    Contact,
    Footer,
  },

  data() {
    return {
      drawer: null,
      items: [
        { title: "About", icon: "mdi-account", anchor: "#about-section" },
        {
          title: "Experience",
          icon: "mdi-view-dashboard",
          anchor: "#skills-section",
        },
        {
          title: "Skills & Tech",
          icon: "mdi-xml",
          anchor: "#skills-tech-section",
        },
        {
          title: "Featured Projects",
          icon: "mdi-image",
          anchor: "#featured-projects",
        },
        { title: "Contact", icon: "mdi-email", anchor: "#contact" },
      ],
    };
  },
};
</script>


<style lang="scss">
@import "./scss/styles.scss";

html,
body {
  max-width: 100%;
  overflow-x: hidden;
}

.mm-logo-header {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-size: 1rem !important;
  padding-left: 0.3rem;
  letter-spacing: 3px;
  color: $white;
  padding-top: 0.6rem;
}
.nav-mcf-flame-logo {
  background-image: url(./assets/images/mm-flame-logo-wtbg.png);
  height: 40px;
  width: 40px;
  background-size: cover;
}
.mcf-app-bar .v-app-bar__nav-icon {
  color: $white !important;
}

.v-toolbar__content {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.mcf-app-bar {
  z-index: 99 !important;
  background-color: unset !important;
  transition-duration: 1.8s !important;
}
// once scrolled
.v-app-bar--is-scrolled {
  .nav-mcf-flame-logo {
    background-image: url(./assets/images/mcf-media-logo.png);
  }
  &.mcf-app-bar {
    background-color: $white !important;
  }
  .mm-logo-header {
    color: rgba(0, 0, 0, 0.87);
  }
  .v-app-bar__nav-icon {
    color: rgba(0, 0, 0, 0.87) !important;
  }
}
// Nav Drawer
.nav-title-cont {
  padding: 1.6rem 0 !important;
}
.nav-title-head {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
}
.v-list--nav {
  padding: 1rem !important;
}
.v-list-item__title {
  font-size: 1rem !important;
}
.nav-drawer {
  z-index: 100 !important;
}
.drawer-icon-cont {
  position: relative;
  widows: 100%;
  .drawer-close {
    position: absolute;
    right: 10px;
    top: 7px;
    z-index: 10;
  }
}
.drawer-header {
  margin-top: 2rem;
}
</style>